import Flx from "../../components/layout/Flx";
import Txt from "../../components/typography/Txt";
import FileUploadField from "../../components/inputs/FileUploadField";

/**
 * One drop zone in the "Prefill Loan Data" section.
 *
 * The two import paths (loan application PDF, EV product sizer) do the same
 * thing from the operator's side — hand over a document, get the form filled —
 * so they're the same control with different copy rather than two affordances
 * that happen to sit near each other. Everything but the icon/title/description
 * is fixed here so neither can drift.
 *
 * `id` is required, not optional: FileUploadField finds its hidden <input> by
 * DOM id, and two cards on one screen without explicit ids would both open the
 * first card's file picker.
 */
const PrefillUploadCard = ({
  id,
  icon,
  title,
  description,
  accept,
  loading,
  onFilesAdded,
}) => (
  <FileUploadField
    id={id}
    accept={accept}
    loading={loading}
    onFilesAdded={onFilesAdded}
    suppressFileList
    suppressUploadButton
    // The card supplies its own icon above the title.
    hideUploadButton
    borderSize={2}
    minHeight="152px"
    sx={{ width: "100%", height: "100%", background: "#ffffff", px: 2 }}
    uploadText={title}
    uploadTextFontSize="14px"
    uploadTextDefaultOpacity={1}
    uploadTextSx={{ fontWeight: 600, color: "text.title" }}
    uploadTextTopContent={
      <Flx center sx={{ mb: 0.75, opacity: 0.75 }}>
        {icon}
      </Flx>
    }
    uploadTextBottomContent={
      <Txt
        secondary
        sx={{
          mt: 0.5,
          fontSize: "11px",
          lineHeight: 1.5,
        }}
      >
        {description}
      </Txt>
    }
  />
);

export default PrefillUploadCard;
